import { useTranslation } from "react-i18next";

// Assets
import addIcon from "../../assets/add_icon.png";

// Components
import CustomInput from "../../components/CustomInput";
import CustomInputWithUnit from "../../components/CustomInputWithUnit";
import CustomButton from "../../components/CustomButton";
import DashboardSection from "../../components/DasboardSection";

const FabricDataEntryModal = ({
  currentGroupCode,
  setCurrentGroupCode,
  setCurrentGroupDesign,
  currentGroupDesign,
  colorInputs,
  setColorInputs,
  isEditMode,
}) => {
  const { t } = useTranslation("general");

  const handleAddColorField = () => {
    setColorInputs([...colorInputs, { colorCode: "", colorName: "" }]);
  };

  const handleColorInputChange = (index, field, value) => {
    const updated = [...colorInputs];
    updated[index][field] = value;
    setColorInputs(updated);
  };

  const handleEnter = (e, index) => {
    if (e.key === "Enter" && index === colorInputs.length - 1) {
      e.preventDefault();
      handleAddColorField();
    }
  };

  return (
    <>
      <div className="c-form-section">
        <label>{t("rulerCode")}</label>
        <CustomInput
          type="text"
          value={currentGroupCode}
          onChange={(e) => setCurrentGroupCode(e.target.value)}
          placeholder={t("example") + "  ER-2280"}
        />
      </div>

      <div className="c-form-section">
        <label>{t("design")}</label>
        <CustomInput
          type="text"
          value={currentGroupDesign}
          onChange={(e) => setCurrentGroupDesign(e.target.value)}
          placeholder={t("example") + " " + t("striped")}
        />
      </div>

      <div className="o-column o-column--gap-size_300 u-margin--top_300">
        <h3 className="u-margin_0">{t("colors")}</h3>
        {colorInputs.map((color, index) => (
          <DashboardSection
            title={`${t("color")} ${index + 1}`}
            classList="u-margin_0"
          >
            <div key={index} className="o-column o-column--gap-size_400">
              <div className="o-row u-width_full-width o-row--gap-size_400">
                <CustomInput
                  type="text"
                  title={t("colorCode")}
                  placeholder={t("colorCode")}
                  value={color.colorCode}
                  onChange={(e) =>
                    handleColorInputChange(index, "colorCode", e.target.value)
                  }
                  onKeyDown={(e) => handleEnter(e, index)}
                  flex
                />
                <CustomInput
                  type="text"
                  title={t("colorName")}
                  placeholder={t("colorName")}
                  value={color.colorName}
                  onChange={(e) =>
                    handleColorInputChange(index, "colorName", e.target.value)
                  }
                  onKeyDown={(e) => handleEnter(e, index)}
                  flex
                />
              </div>

              <div className="o-row u-width_full-width o-row--gap-size_400">
                <CustomInputWithUnit
                  type="number"
                  title={t("quantity")}
                  placeholder={t("quantity")}
                  value={color.availableStock}
                  onChange={(e) =>
                    handleColorInputChange(
                      index,
                      "availableStock",
                      parseFloat(e.target.value)
                    )
                  }
                  onKeyDown={(e) => handleEnter(e, index)}
                  unit={t("METER".toLocaleLowerCase())}
                  flex
                />

                <CustomInputWithUnit
                  type="money"
                  title={isEditMode ? t("averageCost") : t("purchasePrice")}
                  placeholder={t("price")}
                  value={color.purchasePrice}
                  onChange={(e) =>
                    handleColorInputChange(
                      index,
                      "purchasePrice",
                      e.target.value
                    )
                  }
                  onKeyDown={(e) => handleEnter(e, index)}
                  unit={t("USD")}
                  flex
                />
              </div>
            </div>
          </DashboardSection>
        ))}

        <div className="o-row o-row--horizontal-align_end u-margin--top_500">
          <CustomButton
            variant={"blank"}
            onClick={handleAddColorField}
            title={t("addAnotherColor")}
            icon={addIcon}
            iconSize={16}
          />
        </div>
      </div>
    </>
  );
};

export default FabricDataEntryModal;
